export const surfacePalette = {
  0: '#ffffff',
  50: '#f2f2f2',
  100: '#d4d5d7',
  200: '#a2a3a4',
  300: '#5a5d5f',
  400: '#232627',
  500: '#6b7280',
  600: '#4b5563',
  700: '#374151',
  800: '#1f2937',
  900: '#111827'
};
